<template>
  <div class="section" v-if="page==1">
     <img class="unshackled" src="../assets/unshackled.svg">
      <h1 class="findIntro">There are over 75000 CONVICTS in the records. Find your convict by answering the following questions.</h1>
      <CustomButton @click="page=2" :buttonTitle="'CONTINUE'" :buttonIcon="'search'" :buttonColour="'red'"></CustomButton>
    </div>
    <div class="section" v-if="!showResults && page!=1">
      <h1 class="convict-number">{{ possibleText }}</h1>
    </div>
    <div v-show="!showResults">
      <!-- Question 1 -->
       <div class="section" v-show="page==2">
      <div class="question">
        <h1>What is the GENDER of your convict?</h1>
        <div >
          <CustomButton @click="page=3;setGender('Male')" :buttonTitle="'MALE'" :buttonIcon="'maleBTN'" :buttonColour="'grey'"></CustomButton>
          <CustomButton @click="page=3;setGender('Female')" :buttonTitle="'FEMALE'" :buttonIcon="'femaleBtn'" :buttonColour="'grey'"></CustomButton>
        </div>
      </div>
    </div>
     <!-- Question 2 -->
       <div class="section" v-show="page==3">
      <div class="question">
        <h1>What is the NAME of your convict?</h1>
        <div style="display: flex;">
          <dropdown name="gName" placeholder="First Name" :val="gName" @selected="setGivenName" @cleared="silentClear" :options="givenNamesC.length ? givenNamesC : givenNames" maxItems="0"></dropdown>
          <dropdown name="fName" placeholder="Last Name" :val="fName" @selected="setFamilyName" @cleared="silentClear" :options="familyNameC.length ? familyNameC : familyName" maxItems="0" :startsWith=true></dropdown>
        </div>
      </div>
      </div>
    <!-- Question 3 -->
      <div class="section" v-show="page==4">
        <div class="question">
          <h1>What is your convict’s COUNTRY of origin?</h1>
          <div style="display: flex;">
            <dropdown name="country" placeholder="Country" :val="country" @selected="setCountry" :options="countriesC.length ? countriesC : countries" maxItems="0" style="flex: 3;"></dropdown>
          </div>
        </div>
      </div>
      <!-- Checkbox Choices -->
      <div class="section" v-show="page==5" style="margin-top:0px;">
        <h1>What other information do you know about your convict? Select all that apply.</h1>
        <div style="width: 15em; margin: auto;">
          <label v-for="option in checkboxOptions" :key="option.label" class="checkbox">
          <input type="checkbox" :value="option.value" v-model="option.value" />{{ option.label }}</label>
        </div>
      </div>
      <!-- Checkbox Questions -->
      <div class="section" v-if="page==6">
        <div class="question" v-for="(db,dbi) in activeBoxes" :key="'db'+dbi">
       <div v-if="dbi==questionIndex">
          <h1>{{db.question }}</h1>
          <div style="display: flex;">
            
            <dropdown :name="db.field" :placeholder="db.placeholder" :val="db.model ? this[db.model] : null" @selected="db.fn" @cleared="() => silentClearByData(db.data)" :options="this[db.data+'C']" maxItems="0" style="flex: 3;"></dropdown>
            </div>
          </div>
      </div>
       
       
      </div>
    
      <div class="section" v-if="page==6">
        <div class="searchOverlay" :style="'visibility:'+overlayState+';'">
          <h2>{{ overlayText }}</h2>
          <div class="progress-container">
            <div class="progress-bar">
              <div class="progress-bar-filling" :style="progressAnimation"></div>
            </div>
          </div>
        </div>
  </div>
  </div>
  <!-- RESULTS -->
  <div v-if="showResults" >
    <div style="display: flex; justify-content: center; margin-bottom: 0.75em;" class="searchResults">
      <!-- <h3 style="color: var(--grey); margin-right: -0.25em;">Search Results : &nbsp;</h3>
      <h3 v-if="randomCons.length == 0">{{ possCount }} Match<span v-if="possCount != 1">es</span></h3>
      <h3 v-else>{{ randomCons.length }} Matches</h3> -->
    </div>
<!-- CONVICT ENTRIES -->
    <div style="margin-bottom: 6.5em;">
      <!-- <div v-for="(c, ci) in randomCons" :key="'r' + ci">
        <EntryCompact @click="showRandomConvict(ci)" :givenName="c.g+''" :familyName="c.f" :fmnCount="'0'" :viewCount="'0'"
                      :country="c.c" :age="c.a" :trade="c.t" :crime="c.cr" :ship="c.sh" :arrivalYear="c.ya"
                      :flag="flagIcon(c.c)" :iconTrade="personToIcon(c)" :iconCrime="''"></EntryCompact>
      </div> -->

      <div v-if="possCount<=maxResults && randomCons.length==0">
        <h1>We have found {{ foundCountText }} that match your info! <br> Select one below.</h1>
        <div v-for="(c,ci) in possCons" :key="'c'+ci">
          <EntryCompact @click="showConvict(ci)" :givenName="c.g" :familyName="c.f" :fmnCount="'0'" :viewCount="'0'"
                        :country="c.c" :age="c.a" :trade="c.t" :crime="c.cr" :ship="c.sh" :arrivalYear="c.ya"
                        :flag="flagIcon(c.c)" :iconTrade="personToIcon(c)" :iconCrime="''"></EntryCompact>
        </div>
      </div>
    </div>
    </div>

      <CustomButton v-if="page!=1 && !showResults" @click="nextPage" :buttonTitle="nextBtnTitle" :buttonIcon="'search'" :buttonColour="'red'" style="margin-top:2.5em;"></CustomButton>
    <Footer backPath="" @goBack="goBack" @cantFind="cantFind" :backBtn="page>1" :cantFindBtn="page>2" :detailBtn="false"></Footer>

    <!-- Full-screen help modal (stays in FindView context) -->
    <div v-if="showCantFind" class="cf-overlay">
      <div class="cf-content">
        <CantFindView />
        <div style="text-align:center; margin-top: 1em;">
          <CustomButton @click="closeCantFind" :buttonTitle="'CLOSE'" :buttonIcon="'back'" :buttonColour="'grey'" />
        </div>
      </div>
      <div class="cf-backdrop" @click="closeCantFind"></div>
    </div>

    <div v-if="showNarrowPrompt" class="cf-overlay">
      <div class="cf-content narrow-warning">
        <h2>{{ narrowPromptHighCount ? 'Too Many Results' : 'Narrow Your Search' }}</h2>
        <p>
          <template v-if="narrowPromptHighCount">
            We still have more than {{ maxResultsCap }} matching convicts. Please answer another question to refine the list.
          </template>
          <template v-else>
            Please answer at least one question so we can reduce the list of possible convicts.
          </template>
        </p>
        <div style="text-align:center; margin-top: 1em;">
          <CustomButton @click="acknowledgeNarrowPrompt" :buttonTitle="narrowPromptHighCount ? 'REFINE ANSWERS' : 'START AGAIN'" :buttonIcon="'back'" :buttonColour="'red'" />
        </div>
      </div>
      <div class="cf-backdrop" @click="acknowledgeNarrowPrompt"></div>
    </div>
  
</template>

<script>
import flags from '@/mixins/flags.js'
import fields from '@/mixins/fields.js'
import Dropdown from '@/components/DropDown.vue'
import HeaderBar from "@/components/HeaderBar.vue";
import Footer from "@/components/Footer.vue";
import EntryCompact from "@/components/EntryCompact.vue";
import CustomButton from "@/components/CustomButton.vue";
import CantFindView from "@/views/CantFindView.vue";
import dataSet from '!raw-loader!./../assets/data/ConFinder.txt'
export default {
  name: "FindView",
  mixins: [flags,fields],
  components: {
    Dropdown,
    HeaderBar,
    Footer,
    EntryCompact,
    CustomButton,
    CantFindView,
  },
  data() {
    return {
      hasResponse:false,
      questionIndex:0,
      showResults:false,
      checkboxOptions: [
        {"label":"Arrival Ship","question":"What Ship did they arrive on?","value":false,field:"Ship",placeholder:"Ship",data:"ships",model:"ship",fn:this.setShip},
        {"label":"Arrival Year","question":"What Year did they arrive?","value":false,data:"years",placeholder:"Arrival Year",model:"year",fn:this.setYear},
        {"label":"Arrival Age","question":"How old were they when they arrive?","value":false,data:"ages",placeholder:"Age on Arrival",model:"age",fn:this.setAge},
        {"label":"Trade","question":"What trade did they have?","value":false,data:"trades",placeholder:"Trade",model:"trade",fn:this.setTrade},
        {"label":"Crime","question":"What Crime were the convicted of?","value":false,data:"crimes",placeholder:"Crime",model:"crime",fn:this.setCrime}
      //   {"label":"Convict ID","question":"What is their DHT Convict ID?","value":false,placeholder:"DHT Convict ID"}
       ],
      page:1,
      maxResults: 1000,
      maxCons:1000,
      gName: null,
      fName: null,
      country: null,
      age: null,
      gender: null,
      ship: null,
      trade: null,
      year: null,
      crime: null,
      dataSet: null,
      allNames:[],
      possCount: 0,
      possCons:[],
      randomCons:[],
      givenNamesAll:null,
      familyNamesAll:null,
      gendersAll:null,
      shipsAll:null,
      yearsAll:null,
      tradesAll:null,
      crimesAll:null,
      conIndex: 0,
      progressMax: 75000,
      optionsShown:false,
      overlayText:"Loading...",
      overlayState:"hidden",
      isSorted:false,
      showCantFind:false,
      showNarrowPrompt:false,
      narrowPromptHighCount:false,
      maxResultsCap: 500,
    }
  },
  mounted() {
    const inited = this.$store.getters.getDataInitDone
    if (inited) {
      // Hydrate from cached store data; avoid heavy rebuild on each visit
      const cache = this.$store.getters.getFieldsCache || {}
      const clone = (arr)=> Array.isArray(arr) ? arr.concat([]) : []
      this.allNames = clone(this.$store.getters.getAllCons)
      // Basic lists
      this.givenNames = clone(cache.givenNamesAll)
      this.givenNamesC = clone(cache.givenNamesAllC)
      this.familyName = clone(cache.familyNamesAll || cache.familyNameAll)
      this.familyNameC = clone(cache.familyNameAllC)
      this.countries = clone(cache.countriesAll)
      this.countriesC = clone(cache.countriesAllC)
      this.genders = clone(cache.gendersAll)
      this.gendersC = clone(cache.gendersAllC)
      this.ages = clone(cache.agesAll)
      this.agesC = clone(cache.agesAllC)
      this.ships = clone(cache.shipsAll)
      this.shipsC = clone(cache.shipsAllC)
      this.years = clone(cache.yearsAll)
      this.yearsC = clone(cache.yearsAllC)
      this.trades = clone(cache.tradesAll)
      this.tradesC = clone(cache.tradesAllC)
      this.crimes = clone(cache.crimesAll)
      this.crimesC = clone(cache.crimesAllC)
      // Gender buckets
      this.maleCons = clone(cache.maleCons)
      this.femaleCons = clone(cache.femaleCons)
      this.unknownCons = clone(cache.unknownCons)
      this.maleGiven = clone(cache.maleGiven)
      this.maleGivenC = clone(cache.maleGivenC)
      this.femaleGiven = clone(cache.femaleGiven)
      this.femaleGivenC = clone(cache.femaleGivenC)
      this.maleFamily = clone(cache.maleFamily)
      this.maleFamilyC = clone(cache.maleFamilyC)
      this.femaleFamily = clone(cache.femaleFamily)
      this.femaleFamilyC = clone(cache.femaleFamilyC)
      this.overlayState = "hidden"
    } else {
      // First app load: prepare data with overlay
      this.overlayState = "visible"
      this.overlayText = "Accessing Database..."
      setTimeout(this.setUpData, 100)
    }
  },
  created() {
    console.log("created")
  },
  computed: {
    activeBoxes(){
      let active=[]
      for(var b in this.checkboxOptions){
        if(this.checkboxOptions[b].value){
          active.push(this.checkboxOptions[b])
        }
      }
      return active
    },
    possibleText(){
      if(this.possCount==0){
        return "75000+ CONVICTS"
      }else if(this.possCount==1){
        return "1 CONVICT"
      }else{
        return this.possCount+" CONVICTS"
      }
    },
    foundCountText(){
      if(this.possCount==0){
        return "NO CONVICTS"
      }else if(this.possCount==1){
        return "1 CONVICT"
      }else{
        return this.possCount+" CONVICTS"
      }
    },
    reset(){
      return this.$store.getters.getReset
    },
    
    progressAnimation() {
      const width = (this.conIndex / this.progressMax) * 100;
      return {
        width: width + "%"
      };
    },
    isMaxReached() {
      return this.conIndex >= this.progressMax || this.possCount <= maxResults ||!this.fieldSelected;
    },
    fieldSelected(){
      return this.gName || this.fName || this.country || this.age || this.gender || this.ship || this.trade || this.year || this.crime
    },
    genderOnlySelection(){
      return !!this.gender && !this.gName && !this.fName && !this.country && !this.age && !this.ship && !this.trade && !this.year && !this.crime && this.activeBoxes.length === 0
    },
    nextBtnTitle(){
      // Default to SKIP unless a visible dropdown has a selection
      const p = this.page
      let hasSelection = false
      if (p === 3) {
        hasSelection = !!(this.gName || this.fName)
      } else if (p === 4) {
        hasSelection = !!this.country
      } else if (p === 5) {
        // If any checkbox is selected on page 5, change to NEXT
        hasSelection = Array.isArray(this.checkboxOptions)
          && this.checkboxOptions.some(opt => !!opt.value)
      } else if (p === 6) {
        // Determine current dynamic question and check corresponding model
        const current = this.activeBoxes && this.activeBoxes[this.questionIndex]
        if (current) {
          const map = { ships: 'ship', years: 'year', ages: 'age', trades: 'trade', crimes: 'crime' }
          const prop = map[current.data]
          if (prop && Object.prototype.hasOwnProperty.call(this, prop)) {
            hasSelection = !!this[prop]
          }
        }
      }
      return hasSelection ? 'NEXT' : 'SKIP'
    }
  },
  methods: {
    silentClear(field){
      switch(field){
        case 'gName': this.gName = null; break
        case 'fName': this.fName = null; break
        case 'country': this.country = null; break
        case 'gender': this.gender = null; break
        case 'age': this.age = null; break
        case 'ship': this.ship = null; break
        case 'trade': this.trade = null; break
        case 'year': this.year = null; break
        case 'crime': this.crime = null; break
        default: break
      }
      // Recompute options after clearing so full lists are available
      this.filterNames()
    },
    silentClearByData(data){
      // data maps like 'ships','years','ages','trades','crimes'
      switch(data){
        case 'ships': this.ship = null; break
        case 'years': this.year = null; break
        case 'ages': this.age = null; break
        case 'trades': this.trade = null; break
        case 'crimes': this.crime = null; break
        default: break
      }
      // Refresh lists after clearing
      this.filterNames()
    },
    cantFind(){
      this.showCantFind = true
    },
    closeCantFind(){
      this.showCantFind = false
    },
    acknowledgeNarrowPrompt(){
      this.showNarrowPrompt = false
      this.narrowPromptHighCount = false
    },
    promptNarrowSearch(options = {}){
      const { resetToStart = true, highResultCount = false } = options
      this.showResults = false
      if (resetToStart) {
        this.questionIndex = 0
        this.page = 2
      }
      this.overlayState = "hidden"
      this.showNarrowPrompt = true
      this.narrowPromptHighCount = highResultCount
    },
    promptHighResultWarning(){
      this.promptNarrowSearch({ resetToStart: false, highResultCount: true })
    },
    goBack(){
      if(this.showResults){
        this.showResults=false
      }
      if(this.questionIndex>0){
        if(this.questionIndex>0){
          this.questionIndex--
        }else{
          this.page--
        }
      }else if(this.page>9){
        this.questionIndex=0
        this.page=5
      }else if(this.page>0){
        this.page--
      }else{
        this.$router.push("/")
      }
      
    },
    nextPage(){
      if(this.possCons.length>0 && this.possCons.length<6){
        if (!this.fieldSelected || this.genderOnlySelection) {
          this.promptNarrowSearch()
          return
        }
        if (this.possCons.length > this.maxResultsCap) {
          this.promptHighResultWarning()
          return
        }
        this.showResults=true
      }else{
        this.showResults=false
        if(this.page<6){
          if(this.page==5 && this.activeBoxes.length==0){
            if (!this.fieldSelected || this.genderOnlySelection) {
              this.promptNarrowSearch()
              return
            }
            if (this.possCons.length > this.maxResultsCap) {
              this.promptHighResultWarning()
              return
            }
            this.page=10
            this.showResults=true
          }else{
          this.page=this.page+1
          }
        }else{
          if(this.questionIndex<this.activeBoxes.length-1){
            this.questionIndex++
          }else{
            if (!this.fieldSelected || this.genderOnlySelection) {
              this.promptNarrowSearch()
              return
            }
            if (this.possCons.length > this.maxResultsCap) {
              this.promptHighResultWarning()
              return
            }
            this.page=10
            this.showResults=true
          }
        }
      }
    },
    
    showConvict(conIndex) {
      this.$store.commit("setMode","find")
      this.$store.commit("setPossibleConvicts",this.possCons)
      this.$store.commit("setPossibleIndex",conIndex)    
      this.$router.push("/found")
    },
    showRandomConvict(conIndex) {
      this.$store.commit("setMode","find")
      this.$store.commit("setPossibleConvicts",this.randomCons)
      this.$store.commit("setPossibleIndex",conIndex)
      console.log("CLEAR CONS")
      this.randomCons=[]
      this.$router.push("/found")
    },
    
    setGivenName(val){
      if (this.gName === val) return
      this.gName=val
      this.filterNames()
    },
    setFamilyName(val){
      if (this.fName === val) return
      this.fName=val
      this.filterNames()
    },
    setCountry(val){
      if (this.country === val) return
      this.country=val
      this.filterNames()
    },
    setGender(val){
      if (this.gender === val) return
      this.gender=val
      this.filterNames()
    },
    setAge(val){
      if (this.age === val) return
      this.age=val
      this.filterNames()
    },
    setTrade(val){
      if (this.trade === val) return
      this.trade=val
      this.filterNames()
    },
    setCrime(val){
      if (this.crime === val) return
      this.crime=val
      this.filterNames()
    },
    setShip(val){
      if (this.ship === val) return
      this.ship=val
      this.filterNames()
    },
    setYear(val){
      if (this.year === val) return
      this.year=val
      this.filterNames()
    },
    randomConvict(){
      console.log("RANDOM",this.conIndex,this.allNames.length,this.possCons.length)
      // Choose appropriate base set for random selection
      let base
      const isGenderOnly = !!this.gender && !this.gName && !this.fName && !this.country && !this.age && !this.trade && !this.crime && !this.ship && !this.year
      if (!this.fieldSelected) {
        base = this.allNames
      } else if (isGenderOnly && this.possCons.length === 0) {
        if (this.gender === 'Male') base = this.maleCons
        else if (this.gender === 'Female') base = this.femaleCons
        else base = this.unknownCons
      } else if (this.possCons.length > 0) {
        base = this.possCons
      } else {
        base = this.allNames
      }
      this.randomCons = []
      const limit = Math.min(this.maxCons, base.length || 0)
      for (let i = 0; i < limit; i++) {
        this.randomCons.push(base[Math.floor(Math.random() * base.length)])
      }
      this.showRandomConvict(Math.floor(Math.random()*this.randomCons.length))
    },
    
    waitForOptions(){
      if(!this.optionsShown){
       setTimeout(this.processName,100)
       this.overlayText="Filtering Data..."
      }else{
        setTimeout(this.waitForOptions,100)
        this.overlayText="Sorting Data Full..."
      }
    },
    
    setAllCrimes(){
      if(this.crimesAllC){
       this.crimesC=this.crimesAllC.concat([])
      }else{
        let length = this.allNames.length, result = [], seen = new Set();
        outerCR:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].cr;
          if (seen.has(value)) continue outerCR;
          seen.add(value);
          result.push(value);
        }
        this.crimesC =Array.from(seen).sort()
      }
        this.overlayText="Sorting Ships..."
        this.conIndex = 70000;
        setTimeout(this.setAllShips,10)
    },
    setAllGNames(){
      if(this.givenNamesAll || this.givenNamesAllC){
       if (this.givenNamesAll) this.givenNames=this.givenNamesAll.concat([])
       if (this.givenNamesAllC) this.givenNamesC=this.givenNamesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
     
        outerG:  

        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].g;
          if (seen.has(value)) continue outerG;
          seen.add(value);
          result.push(value);

        }
        this.givenNames=Array.from(seen).sort()
      }
        this.overlayText="Sorting Family Names..."
        this.conIndex = 40000;
        setTimeout(this.setAllFNames,10)
    },
    setAllFNames(){
      if(this.familyNameAll || this.familyNameAllC){
       if (this.familyNameAll) this.familyName=this.familyNameAll.concat([])
        if (this.familyNameAllC) this.familyNameC=this.familyNameAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
      outerF:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].f;
          if (seen.has(value)) continue outerF;
          seen.add(value);
          result.push(value);
        }
        
        this.familyName=Array.from(seen).sort()
      }
      this.overlayText="Sorting Countries..."
        this.conIndex = 45000;
        setTimeout(this.setAllCountries,10)
    },
    setAllCountries(){
      if(this.countriesAll || this.countriesAllC){
       if (this.countriesAll) this.countries=this.countriesAll.concat([])
       if (this.countriesAllC) this.countriesC=this.countriesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        outerC:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].c;
          if (seen.has(value)) continue outerC;
          seen.add(value);
          result.push(value);
        }
        this.countries =Array.from(seen).sort()
      }
        this.overlayText="Sorting Genders..."
        this.conIndex = 50000;
        setTimeout(this.setAllGenders,10)
    },
    setAllAges(){
      if(this.agesAll || this.agesAllC){
       if (this.agesAll) this.ages=this.agesAll.concat([])
       if (this.agesAllC) this.agesC=this.agesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        
        outerA:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].a;
          if (seen.has(value)) continue outerA;
          seen.add(value);
          result.push(value);
        }
        this.ages  =Array.from(seen).sort()
      }
        this.overlayText="Sorting Trades..."
        this.conIndex = 60000;
        setTimeout(this.setAllTrades,10)
    },
    setAllGenders(){
      if(this.gendersAll || this.gendersAllC){
       if (this.gendersAll) this.genders=this.gendersAll.concat([])
       if (this.gendersAllC) this.gendersC=this.gendersAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        outerS:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].s;
          if (seen.has(value)) continue outerS;
          seen.add(value);
          result.push(value);
        }
        this.genders =Array.from(seen).sort()
      }
        this.overlayText="Sorting Ages..."
        this.conIndex = 55000;
        setTimeout(this.setAllAges,10)
    },
    setAllShips(){
      if(this.shipsAllC){
       this.shipsC=this.shipsAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        
        outerSH:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].sh;
          if (seen.has(value)) continue outerSH;
          seen.add(value);
          result.push(value);
        }
        this.shipsC =Array.from(seen).sort()
      }
        this.overlayText="Sorting Arrival Years..."
        this.conIndex = 75000;
        setTimeout(this.setAllYears,10)
    },
    setAllTrades(){
      if(this.tradesAllC){
       this.tradesC=this.tradesAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();
        
        outerT:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].t;
          if (seen.has(value)) continue outerT;
          seen.add(value);
          result.push(value);
        }
        this.tradesC =Array.from(seen).sort()
      }
        this.overlayText="Sorting Crimes..."
        this.conIndex = 65000;
        setTimeout(this.setAllCrimes,10)
    },
    setAllYears(){
      if(this.yearsAll || this.yearsAllC){
       if (this.yearsAll) this.years=this.yearsAll.concat([])
       if (this.yearsAllC) this.yearsC=this.yearsAllC.concat([])
      }else{
      let length = this.allNames.length, result = [], seen = new Set();

        outerYA:  
        for (let index = 0; index < length; index++) {
          let value =this.allNames[index].ya;
          if (seen.has(value)) continue outerYA;
          seen.add(value);
          result.push(value);
        }
        this.years =Array.from(seen).sort()
      }
        //this.overlayText="Done"
        this.overlayState="hidden"
        //this.possCount=length
    },

    
    clearReset(){
      console.log("CLEAR RESET FROM SEARCH")
      this.$store.commit("setReset",false)
      //setTimeout(this.setUpData,100)
    }
    
  },
  watch:{
    reset(val){
      if(val){
        this.resetData()
        console.log("DO RESET FROM SEARCH")
        setTimeout(this.clearReset,500)
      }
     
    },
  }
};
</script>

<style>
.cf-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5000;
}
.cf-backdrop {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.8);
}
.cf-content {
  position: relative;
  width: 90vw;
  height: 90vh;
  margin: 5vh auto;
  background: var(--charcoal);
  border-radius: 0.5em;
  padding: 1em;
  z-index: 5001;
  box-shadow: 0 0 30px rgba(0,0,0,0.6);
}
.cf-content.narrow-warning {
  max-width: 28rem;
  height: auto;
  text-align: center;
}
.cf-content.narrow-warning h2 {
  margin-bottom: 0.5em;
}
.cf-content.narrow-warning p {
  margin: 0;
  line-height: 1.25;
}
.searchPanel {
  position: relative;
  height:90px;
}
.searchOverlay {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  background-color: #19191977;

  z-index: 2000;

      height: 100vh;
    
    position: fixed;
}
.refine-search {
  color: var(--brick);
  padding: 1.5em 0 1.25em;
  margin: 0;
  margin-bottom: 1.1em;
  border-top: 1px solid var(--brick);
  border-bottom: 1px solid var(--brick);
}
.progress-container {
  display: flex;
  justify-content: center;
}
.progress-bar {
  width: 13em;
  height: 0.5em;
  background-color: var(--brick);
  border-radius: 1em;
  margin: 0.25em 0 0.5em;
}
.progress-bar-filling {
  width: 0%;
  height: 0.5em;
  background-color: var(--warm-sandstone);
  border-radius: 1em;
}
.checkbox {
  display: flex;
  align-items: center;
  font-size: 2em;
  line-height: 1em;
  margin: 0.5em;
  gap: 1em;
  input {
    transform: scale(1.5);
  }
}
.searchResults{
  h3{font-size:1.5em;}
}
.unshackled {
  width: clamp(18rem, 90vw, 33rem);
  max-width: 100%;
  height: auto;
}
@media (max-width: 500px) {
  .section{
    gap:0px;
  }
  h1{
            margin: 0em;
  }
  .findIntro{
     margin: 1em;
  }
  .unshackled {
    width: min(80vw, 18rem);
  }
    
}

</style>
